import { Newspaper } from "lucide-react";

/* Blog listing tour — a single "Read a post" step highlighting the first
   article card (matches the provided mockup: Step 1 of 1). */
export default function getBlogsTourSteps() {
  return [
    {
      cardSelector: '[data-tour="bl-card"]',
      targetSelector: '[data-tour="bl-card"]',
      icon: <Newspaper />,
      title: "Read a post",
      text: "Tap any post to read the full article.",
    },
  ];
}
